"use strict";
// Errors constructed from:
// https://github.com/gnolang/gno/blob/master/tm2/pkg/std/errors.go
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasOverflowErrorMessage = exports.NoSignaturesErrorMessage = exports.TooManySignaturesErrorMessage = exports.InsufficientFeeErrorMessage = exports.MemoTooLargeErrorMessage = exports.OutOfGasErrorMessage = exports.InvalidGasWantedErrorMessage = exports.InvalidCoinsErrorMessage = exports.InsufficientCoinsErrorMessage = exports.InvalidPubKeyErrorMessage = exports.UnknownAddressErrorMessage = exports.InvalidAddressErrorMessage = exports.UnknownRequestErrorMessage = exports.InsufficientFundsErrorMessage = exports.UnauthorizedErrorMessage = exports.InvalidSequenceErrorMessage = exports.TxDecodeErrorMessage = exports.InternalErrorMessage = void 0;
var InternalErrorMessage = 'internal error encountered';
exports.InternalErrorMessage = InternalErrorMessage;
var TxDecodeErrorMessage = 'unable to decode tx';
exports.TxDecodeErrorMessage = TxDecodeErrorMessage;
var InvalidSequenceErrorMessage = 'invalid sequence';
exports.InvalidSequenceErrorMessage = InvalidSequenceErrorMessage;
var UnauthorizedErrorMessage = 'signature is unauthorized';
exports.UnauthorizedErrorMessage = UnauthorizedErrorMessage;
var InsufficientFundsErrorMessage = 'insufficient funds';
exports.InsufficientFundsErrorMessage = InsufficientFundsErrorMessage;
var UnknownRequestErrorMessage = 'unknown request';
exports.UnknownRequestErrorMessage = UnknownRequestErrorMessage;
var InvalidAddressErrorMessage = 'invalid address';
exports.InvalidAddressErrorMessage = InvalidAddressErrorMessage;
var UnknownAddressErrorMessage = 'unknown address';
exports.UnknownAddressErrorMessage = UnknownAddressErrorMessage;
var InvalidPubKeyErrorMessage = 'invalid pubkey';
exports.InvalidPubKeyErrorMessage = InvalidPubKeyErrorMessage;
var InsufficientCoinsErrorMessage = 'insufficient coins';
exports.InsufficientCoinsErrorMessage = InsufficientCoinsErrorMessage;
var InvalidCoinsErrorMessage = 'invalid coins';
exports.InvalidCoinsErrorMessage = InvalidCoinsErrorMessage;
var InvalidGasWantedErrorMessage = 'invalid gas wanted';
exports.InvalidGasWantedErrorMessage = InvalidGasWantedErrorMessage;
var OutOfGasErrorMessage = 'out of gas';
exports.OutOfGasErrorMessage = OutOfGasErrorMessage;
var MemoTooLargeErrorMessage = 'memo too large';
exports.MemoTooLargeErrorMessage = MemoTooLargeErrorMessage;
var InsufficientFeeErrorMessage = 'insufficient fee';
exports.InsufficientFeeErrorMessage = InsufficientFeeErrorMessage;
var TooManySignaturesErrorMessage = 'too many signatures';
exports.TooManySignaturesErrorMessage = TooManySignaturesErrorMessage;
var NoSignaturesErrorMessage = 'no signatures';
exports.NoSignaturesErrorMessage = NoSignaturesErrorMessage;
var GasOverflowErrorMessage = 'gas overflow';
exports.GasOverflowErrorMessage = GasOverflowErrorMessage;
